import { FormControl, FormGroup, Validators } from '@angular/forms';

export class PhoneNumberEditForm extends FormGroup {
  constructor(phoneNumber: string = '') {
    super({
      phoneNumber: new FormControl(phoneNumber, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
    });
  }

  get phoneNumber(): FormControl {
    return this.get('phoneNumber') as FormControl;
  }
}
